export var BaseSizes;

(function (BaseSizes) {
  BaseSizes["xs"] = "xs";
  BaseSizes["sm"] = "sm";
  BaseSizes["md"] = "md";
  BaseSizes["lg"] = "lg";
  BaseSizes["xl"] = "xl";
  BaseSizes["2xl"] = "2xl";
  BaseSizes["3xl"] = "3xl";
  BaseSizes["4xl"] = "4xl";
})(BaseSizes || (BaseSizes = {}));

export var DeviceSizes;

(function (DeviceSizes) {
  DeviceSizes["sm"] = "Sm";
  DeviceSizes["md"] = "Md";
  DeviceSizes["lg"] = "Lg";
  DeviceSizes["xl"] = "Xl";
  DeviceSizes["xl2"] = "_2xl";
})(DeviceSizes || (DeviceSizes = {}));